import React, { useCallback, useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "../utils/NotFound";
import HomeEmployee from "../components/merchant-employee/home";
import {
  CustomerOrderInfo,
  PermissionInfo,
  SubscriptionInfo,
  UserInfo,
} from "../context";
import axios from "axios";
import MerchantEmployeeOrders from "../components/merchant-employee/cashiering";
import MerchantEmployeeProduction from "../components/merchant-employee/production";
import MerchantEmployeeNowServing from "../components/merchant-employee/cashiering/now-serving";
import _ from "lodash";
import beep from "./../assets/notification6.mp3";
import MerchantEmployeeWaiter from "../components/merchant-employee/waiter";
import MerchantEmployeeOrderPayLater from "../components/merchant-employee/cashiering/pay-later";
import moment from "moment";
import DialogCashFunds from "../utils/merchant-employee/DialogCashFunds";
import MerchantEmployeeCashCount from "../components/merchant-employee/cashiering/cash-count";
import MerchantEmployeeProducts from "../components/merchant-employee/team-leader/products";
import MerchantEmployeeList from "../components/merchant-employee/team-leader/permission";
import MerchantEmployeeReports from "../components/merchant-employee/team-leader/reports";
import MerchantEmployeeToBillOut from "../components/merchant-employee/waiter/billoutlist";
import DialogPrevEmployeeNotDone from "../utils/merchant-employee/DialogPrevEmployeeNotDone";
import MerchantEmployeeTeamLeaderCashCount from "../components/merchant-employee/team-leader/cash-count";
import MerchantEmployeeInvReport from "../components/merchant-employee/inventory-report";
import MerchantEmployeeOtherTransactions from "../components/merchant-employee/cashiering/other-transaction";
// import MerchantEmployeeForCheckout from "../components/merchant-employee/cashiering/additional-services/for-checkout";
import MerchantEmployeeAccountsReceivable from "../components/merchant-employee/cashiering/account-receivable";
import MerchantEmployeeAccountingReports from "../components/merchant-employee/accounting/report";
import MerchantEmployeeAddtionalServices from "../components/merchant-employee/cashiering/additional-services";
import MerchantEmployeeHouseKeeping from "../components/merchant-employee/house-keeping";
import MerchantEmployeeExpenseTab from "../components/merchant-employee/accounting/expense";

const MerchantEmployeeRoute = () => {
  const soundNotif = new Audio(beep);

  const { channel, userData } = useContext(UserInfo);
  const [permissionList, setPermissionList] = useState({
    data: [],
    ready: false,
  });
  const [subscriptionDetails, setSubscriptionDetails] = useState({
    data: [],
    ready: false,
  });
  const [merchantOrderSaveList, setMerchantOrderSaveList] = useState({
    data: [],
    ready: false,
  });
  const [nowServingList, setNowServingList] = useState({
    data: [],
    ready: false,
  });
  const [toProductionList, setToProductionList] = useState({
    data: [],
    ready: false,
  });
  const [merchantPayLaterList, setMerchantPayLaterList] = useState({
    data: [],
    ready: false,
  });
  const [dailyCashFundList, setDailyCashFundList] = useState({
    data: [],
    ready: false,
  });
  const [additionalService, setAdditionalService] = useState({
    data: [],
    ready: false,
  });
  const [openModal, setOpenModal] = useState(false);
  const [openModalPrevEmployee, setOpenModalPrevEmployee] = useState(false);
  const date_now = moment(
    `${moment().format("YYYY-MM-DDTHH:mm:ss.000000Z")}`
  ).format("YYYY-MM-DD");

  // IF CASHIER ALSO RUN DETECT CASH COUNT
  const getMyPermissions = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      merchant_user_id: userData.data.usersmerchantemployee.merchant_user_id,
    };
    axios
      .get("user/merchant-employee/permission-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setPermissionList({ data, ready: true });
        data.result.find(({ permission }) => permission === "cashiering") &&
          getCashCountDailyDetection(data.merchant_info, data.store_permission);
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getSubscriptionDetails = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
    };
    axios
      .get("user/merchant/subscription-details", { params })
      .then((response) => {
        const data = response.data;
        setSubscriptionDetails({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getCashCountDailyDetection = useCallback(
    (merchant, store_permission) => {
      var date_from = "";
      var date_to = "";
      if (
        merchant.operation_opens !== null &&
        merchant.operation_closes !== null
      ) {
        if (merchant.operation_closes < merchant.operation_opens) {
          if (moment().format("HH:mm:ss") >= merchant.operation_closes) {
            date_from = moment(
              `${date_now}T${merchant.operation_opens}`
            ).format("YYYY-MM-DDTHH:mm:ss");
            date_to = moment(`${date_now}T${merchant.operation_closes}`)
              .add(1, "days")
              .format("YYYY-MM-DDTHH:mm:ss");
          } else {
            date_from = moment(`${date_now}T${merchant.operation_opens}`)
              .subtract(1, "days")
              .format("YYYY-MM-DDTHH:mm:ss");
            date_to = moment(`${date_now}T${merchant.operation_closes}`).format(
              "YYYY-MM-DDTHH:mm:ss"
            );
          }
        } else {
          date_from = moment(`${date_now}T${merchant.operation_opens}`).format(
            "YYYY-MM-DDTHH:mm:ss"
          );
          date_to = moment(`${date_now}T${merchant.operation_closes}`).format(
            "YYYY-MM-DDTHH:mm:ss"
          );
        }
      } else {
        date_from = moment(`${date_now}T00:00:00`).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
        date_to = moment(`${date_now}T23:59:00`).format("YYYY-MM-DDTHH:mm:ss");
      }

      var params = {
        user_id: userData.data.id,
        merchant_user_id: userData.data.usersmerchantemployee.merchant_user_id,
        date_from,
        date_to,
      };
      axios
        .get("user/merchant-employee/cash-count-daily", {
          params,
        })
        .then((response) => {
          const data = response.data;
          if (
            store_permission.length > 0 &&
            store_permission.find(
              ({ permission }) => permission === "allow-multiple-cashier"
            )
          ) {
            // console.log("GOTCHA");
            // console.log("DATA: ", data.date_now_detect);
            if (parseInt(data.date_now_detect) < 1) {
              setOpenModal(true);
            }
          } else {
            if (parseInt(data.prev_employee_not_done) > 0) {
              setOpenModalPrevEmployee(true);
            } else if (parseInt(data.date_now_detect) < 1) {
              setOpenModal(true);
            }
          }
          setDailyCashFundList({ data: data, ready: true });
        })
        .catch((error) => {
          console.log("ERROR: ", error);
        });
    },
    [userData.data.usersmerchantemployee.merchant_user_id]
  );

  useEffect(() => {
    getMyPermissions();
    getSubscriptionDetails();
  }, [getMyPermissions, getSubscriptionDetails]);

  const getMerchantOrderSaveList = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      status: 0,
      orderby: "asc",
      order_category: "products",
    };
    axios
      .get("user/merchant/customer-order-list", {
        params,
      })
      .then((response) => {
        const res = _.chain(response.data)
          .groupBy((g) => g.transaction_id)
          .map((value, key) => ({
            transaction_id: key,
            data: value,
            customer_name: value[0].customer_name,
            created_at: value[0].created_at,
            table_no: value[0].table_no,
            service_category: value[0].service_category,
            cost: getTotalCost(value),
          }))
          .value();
        const res2 = _.orderBy(res, ["created_at"], ["desc"]);
        setMerchantOrderSaveList({ data: res2, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  const getNowServing = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      status: 1,
      production_complete: 1,
      merchant_complete: 0,
      orderby: "asc",
    };
    axios
      .get("user/merchant/complete/customer-order-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setNowServingList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  const getToProduction = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      status: 1,
      production_complete: 0,
      orderby: "asc",
      sub_category:
        userData.data.usersmerchantemployee.station_id !== null
          ? userData.data.usersmerchantemployee.station_id
          : "all",
    };
    axios
      .get("user/merchant/production/customer-order-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setToProductionList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  const getPayLaterOrders = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      status: 1,
      orderby: "asc",
      order_category: "products",
    };
    axios
      .get("user/merchant/pay-later-list", {
        params,
      })
      .then((response) => {
        const res = _.chain(response.data)
          .groupBy((g) => g.transaction_id)
          .map((value, key) => ({
            transaction_id: key,
            data: value,
            customer_name: value[0].customer_name,
            created_at: value[0].created_at,
            table_no: value[0].table_no,
            service_category: value[0].service_category,
          }))
          .value();
        const res2 = _.orderBy(res, ["created_at"], ["desc"]);
        setMerchantPayLaterList({ data: res2, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  const getAdditionalService = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      status: 0,
      orderby: "asc",
      order_category: "additional-service",
      allow_housekeeping:
        permissionList.ready &&
        permissionList.data.store_permission.length > 0 &&
        permissionList.data.store_permission.find(
          ({ permission }) => permission === "allow-house-keeping"
        )
          ? "yes"
          : "no",
    };
    axios
      .get("user/merchant/customer-order-list", {
        params,
      })
      .then((response) => {
        const res = _.chain(response.data)
          .groupBy((g) => g.transaction_id)
          .map((value, key) => ({
            transaction_id: key,
            data: value,
            customer_name: value[0].customer_name,
            created_at: value[0].created_at,
            table_no: value[0].table_no,
            service_category: value[0].service_category,
            started_date: value[0].started_date,
            ended_date: value[0].ended_date,
            service_type: value[0].service_type,
          }))
          .value();
        const res2 = _.orderBy(res, ["created_at"], ["desc"]);
        setAdditionalService({ data: res2, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [
    userData.data.usersmerchantemployee.merchant_user_id,
    permissionList.data.store_permission,
  ]);

  useEffect(() => {
    if (
      permissionList.ready &&
      parseInt(permissionList.data.merchant_info.is_production) === 1
    ) {
      if (
        permissionList.data.result.find(
          ({ permission }) => permission === "cashiering"
        )
      ) {
        getMerchantOrderSaveList();
        getPayLaterOrders();
        getAdditionalService();
      }
      if (
        permissionList.data.result.find(
          ({ permission }) =>
            permission === "waiter" || permission === "cashiering"
        )
      ) {
        getNowServing();
      }
      if (
        permissionList.data.result.find(
          ({ permission }) => permission === "production"
        )
      ) {
        getToProduction();
      }
      if (
        permissionList.data.result.find(
          ({ permission }) => permission === "team-leader"
        )
      ) {
        getMerchantOrderSaveList();
      }
    }

    channel.bind(
      "customer-order-" + userData.data.usersmerchantemployee.merchant_uid,
      function (data) {
        if (data.event_code === "customer-order-list") {
          if (
            permissionList.ready &&
            parseInt(permissionList.data.merchant_info.is_production) === 1
          ) {
            if (
              permissionList.data.result.find(
                ({ permission }) =>
                  permission === "cashiering" || permission === "team-leader"
              )
            ) {
              soundNotif.play();
              getMerchantOrderSaveList();
            }
            if (
              permissionList.data.result.find(
                ({ permission }) => permission === "cashiering"
              )
            ) {
              getPayLaterOrders();
            }
          }
        }
      }
    );

    channel.bind(
      "customer-production-" + userData.data.usersmerchantemployee.merchant_uid,
      function (data) {
        if (data.event_code === "customer-production-list") {
          if (
            permissionList.ready &&
            parseInt(permissionList.data.merchant_info.is_production) === 1
          ) {
            if (
              permissionList.data.result.find(
                ({ permission }) => permission === "production"
              )
            ) {
              soundNotif.play();
              getToProduction();
            }
            if (
              permissionList.data.result.find(
                ({ permission }) =>
                  permission === "cashiering" || permission === "team-leader"
              )
            ) {
              getMerchantOrderSaveList();
            }
          }
        }
      }
    );

    channel.bind(
      "customer-now-serving-" +
        userData.data.usersmerchantemployee.merchant_uid,
      function (data) {
        if (data.event_code === "customer-now-serving-list") {
          if (
            permissionList.ready &&
            parseInt(permissionList.data.merchant_info.is_production) === 1
          ) {
            if (
              permissionList.data.result.find(
                ({ permission }) =>
                  permission === "waiter" || permission === "cashiering"
              )
            ) {
              soundNotif.play();
              getNowServing();
            }
            if (
              permissionList.data.result.find(
                ({ permission }) => permission === "production"
              )
            ) {
              getToProduction();
            }
          }
        }
      }
    );

    return () => {
      channel.unbind(
        "customer-order-" + userData.data.usersmerchantemployee.merchant_user_id
      );
      channel.unbind(
        "customer-production-" +
          userData.data.usersmerchantemployee.merchant_user_id
      );
      channel.unbind(
        "customer-now-serving-" +
          userData.data.usersmerchantemployee.merchant_user_id
      );
    };
  }, [
    permissionList,
    getMerchantOrderSaveList,
    getToProduction,
    getPayLaterOrders,
    getNowServing,
    getAdditionalService,
  ]);

  const getTotalCost = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseInt(data[i].is_per_piece) === 1
          ? parseInt(data[i].quantity) *
            parseFloat(data[i].price.replace(",", ""))
          : parseFloat(data[i].price.replace(",", ""));
    }
    return total;
  };

  return (
    <>
      {permissionList.ready && subscriptionDetails.ready && (
        <PermissionInfo.Provider
          value={{
            permissionList,
          }}
        >
          <SubscriptionInfo.Provider
            value={{
              subscriptionDetails,
            }}
          >
            <CustomerOrderInfo.Provider
              value={{
                merchantOrderSaveList,
                rerunCustomerOrders: () => getMerchantOrderSaveList(),
                nowServingList,
                rerunNowServing: () => getNowServing(),
                toProductionList,
                rerunToProduction: () => getToProduction(),
                merchantPayLaterList,
                rerunPayLater: () => getPayLaterOrders(),
                additionalService,
                rerunAdditionalService: () => getAdditionalService(),
                dailyCashFundList,
                rerunDailyCashFund: () =>
                  getCashCountDailyDetection(
                    permissionList.data.merchant_info,
                    permissionList.data.store_permission
                  ),
              }}
            >
              <React.Fragment>
                <Routes>
                  <Route path="/" element={<HomeEmployee />} />

                  {/* ----------------- CASHIERING ----------------- */}

                  {permissionList.data.result.find(
                    ({ permission }) =>
                      permission === "cashiering" ||
                      permission === "team-leader"
                  ) ? (
                    <Route
                      path="/waiting"
                      element={
                        <MerchantEmployeeOrders
                          account={
                            permissionList.data.result.find(
                              ({ permission }) => permission === "team-leader"
                            )
                              ? "team-leader"
                              : "cashier"
                          }
                        />
                      }
                    />
                  ) : null}

                  {permissionList.data.result.find(
                    ({ permission }) => permission === "cashiering"
                  ) ? (
                    <>
                      <Route
                        path="/now-serving"
                        element={<MerchantEmployeeNowServing />}
                      />
                      <Route
                        path="/pay-later"
                        element={<MerchantEmployeeOrderPayLater />}
                      />
                      <Route
                        path="/cash-count"
                        element={<MerchantEmployeeCashCount />}
                      />
                      <Route
                        path="/other-transaction"
                        element={<MerchantEmployeeOtherTransactions />}
                      />
                      <Route
                        path="/additional-services"
                        element={
                          <MerchantEmployeeAddtionalServices
                            account={
                              permissionList.data.result.find(
                                ({ permission }) => permission === "team-leader"
                              )
                                ? "team-leader"
                                : "cashier"
                            }
                          />
                        }
                      />
                      <Route
                        path="/account-receivable"
                        element={
                          <MerchantEmployeeAccountsReceivable
                            account={
                              permissionList.data.result.find(
                                ({ permission }) => permission === "team-leader"
                              )
                                ? "team-leader"
                                : "cashier"
                            }
                          />
                        }
                      />
                    </>
                  ) : null}

                  {/* ----------------- PRODUCTION ----------------- */}
                  {permissionList.data.result.find(
                    ({ permission }) => permission === "production"
                  ) ? (
                    <Route
                      path="/production"
                      element={<MerchantEmployeeProduction />}
                    />
                  ) : null}

                  {/* ------------------ WAITER ------------------ */}
                  {permissionList.data.result.find(
                    ({ permission }) => permission === "waiter"
                  ) ? (
                    <Route
                      path="/waiter"
                      element={<MerchantEmployeeWaiter />}
                    />
                  ) : null}
                  {permissionList.data.result.find(
                    ({ permission }) => permission === "waiter"
                  ) ? (
                    <Route
                      path="/to-bill-out"
                      element={<MerchantEmployeeToBillOut />}
                    />
                  ) : null}

                  {/* ------------------ TEAM LEADER ------------------ */}
                  {permissionList.data.result.find(
                    ({ permission }) => permission === "team-leader"
                  ) ? (
                    <>
                      <Route
                        path="/products"
                        element={<MerchantEmployeeProducts />}
                      />
                      <Route
                        path="/employee-permissions"
                        element={<MerchantEmployeeList />}
                      />
                      <Route
                        path="/report"
                        element={<MerchantEmployeeReports />}
                      />
                      <Route
                        path="/tl/cash-count"
                        element={<MerchantEmployeeTeamLeaderCashCount />}
                      />
                    </>
                  ) : null}

                  {/* ------------------ INVENTORY REPORT ------------------ */}
                  {permissionList.data.result.find(
                    ({ permission }) => permission === "inventory-report"
                  ) ? (
                    <Route
                      path="/inventory-report"
                      element={<MerchantEmployeeInvReport />}
                    />
                  ) : null}

                  {/* ------------------ ACCOUNTING ------------------ */}
                  {permissionList.data.result.find(
                    ({ permission }) => permission === "accounting"
                  ) ? (
                    <>
                      <Route
                        path="/accounting/report"
                        element={<MerchantEmployeeAccountingReports />}
                      />
                      <Route
                        path="/accounting/expense"
                        element={<MerchantEmployeeExpenseTab />}
                      />
                    </>
                  ) : null}

                  {/* ---------------- HOUSE KEEPING ---------------- */}
                  {permissionList.data.result.find(
                    ({ permission }) => permission === "house-keeping"
                  ) ? (
                    <Route
                      path="/house-keeping/room-status"
                      element={<MerchantEmployeeHouseKeeping />}
                    />
                  ) : null}

                  <Route path="*" element={<NotFound />} />
                </Routes>
              </React.Fragment>
            </CustomerOrderInfo.Provider>
          </SubscriptionInfo.Provider>
        </PermissionInfo.Provider>
      )}

      {openModal && (
        <DialogCashFunds
          open={openModal}
          close={() => setOpenModal(false)}
          rerun={() =>
            getCashCountDailyDetection(
              permissionList.data.merchant_info,
              permissionList.data.store_permission
            )
          }
        />
      )}

      {openModalPrevEmployee && (
        <DialogPrevEmployeeNotDone open={openModalPrevEmployee} />
      )}
    </>
  );
};

export default MerchantEmployeeRoute;
